import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_TIMELINE_BANNERS, res.data)
  })
)

export const show = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_TIMELINE_BANNER, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.saveBanner(obj).then(res => {
    commit(types.SET_TIMELINE_BANNER, res.data.data)
    return res
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}

export const orderList = async ({ commit }, obj) => {
  await services.orderList(obj).then(res => {
    commit(types.SET_TIMELINE_BANNERS, res.data)
    return res.data
  })
}

export const deleteVideo = async ({ commit }, obj) => {
  await services.deleteVideo(obj).then(res => {
    return res
  })
}
